import React, {useState} from "react";
import {useFulfillmentType} from "@widgets/pos/order/hooks/UseFulfillmentType";
import useProductInfo from "../context/ProductInfoProvider";
import {productPlaceholderImgSrc} from "@/data/entities/product";
import {getFormattedProductPrice} from "@/utils/MoneyUtils";
import ProductStockToggle from "@widgets/pos/order/menu/product/stock/ProductStockToggle";

const ProductHeader = () => {
    const fulfillmentType = useFulfillmentType();
    const {product} = useProductInfo();
    const [imgSrc, setImgSrc] = useState(product.images.length > 0 ? product.images[0] : productPlaceholderImgSrc);

    return (
        <header className={"w-full flex flex-row items-start justify-start gap-3"}>
            <img
                className={"size-[145px] object-cover rounded-xl shrink-0 grow-0 bg-yellow-400/10"}
                src={imgSrc}
                onError={() => setImgSrc(productPlaceholderImgSrc)}
                alt={product.name}
                width={130}
                height={130}
                loading={"lazy"}
            />

            <div className={"flex w-full flex-col items-start justify-start gap-1"}>
                <ProductStockToggle/>

                <p className={"w-full text-gray-500 dark:text-slate-400"}>
                    {product.description}
                </p>

                <div className={"w-full flex flex-row items-center justify-start gap-2 mt-1"}>
                    <data className={"font-medium text-base"}>
                        {getFormattedProductPrice(product, fulfillmentType)}
                    </data>
                </div>
            </div>
        </header>
    );
};

export default ProductHeader;